import { RHFSelect } from '@talentmesh/ui/components/rhf-select';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';
import employmentTypeOptions from './employmentTypeOptions';
import UIStrings from '@/Utils/UIStrings';

function EmploymentType() {
    const options = employmentTypeOptions.map((o) => ({ id: String(o.id), name: o.name }));

    return (
        <RHFSelect
            label={`${UIStrings.EmploymentType}*`}
            name={JobDetailsFieldTypes.EmploymentType}
            options={options}
            fieldDataCy={JobDetailsFieldTypes.EmploymentType}
        />
    );
}

export default EmploymentType;
